/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetPaymentRequestEvidenceRecords200ResponseInnerErrors
 */
export interface GetPaymentRequestEvidenceRecords200ResponseInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerErrors
     */
    'detectedDpi'?: GetPaymentRequestEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerErrors
     */
    'calculatedDpi'?: GetPaymentRequestEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerErrors
     */
    'colorGradation'?: GetPaymentRequestEvidenceRecords200ResponseInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerErrors
     */
    'heightMillis'?: GetPaymentRequestEvidenceRecords200ResponseInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerErrors
     */
    'widthMillis'?: GetPaymentRequestEvidenceRecords200ResponseInnerErrorsWidthMillisEnum;
}

export const GetPaymentRequestEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerErrorsColorGradationEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsColorGradationEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsColorGradationEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerErrorsHeightMillisEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsHeightMillisEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsHeightMillisEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerErrorsWidthMillisEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsWidthMillisEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsWidthMillisEnum];


